export const GET_MEETING_NOTIFICATION = '/api/meeting/get-notifications';
export const ACCEPT_OR_REJECT_MEETING = '/api/meeting/accept-or-reject-meeting';
